'use strict';
import React from 'react';
import ImageViewerButtons from 'components/imageViewer/imageViewerButtons';

var ImageViewer = React.createClass({
    displayName: 'ImageViewer',

    getInitialState: function () {
        return {
            x: 0,
            y: 0,
            scale: 1,
            minScale: 1,
            maxScale: 4
        };
    },

    componentDidMount: function () {
        document.addEventListener("mousemove", this.handleMouseMove, false);
        document.addEventListener("wheel", this.handleWheel, { passive: false });
    },

    componentWillUnmount: function () {
        document.removeEventListener("mousemove", this.handleMouseMove, false);
        document.removeEventListener("wheel", this.handleWheel, { passive: false });
    },
    /** reset scale and tranlate when we receive a new image. */
    componentWillReceiveProps(nextProps) {
        if (this.props.src != nextProps.src) {
            this.setState(this.getInitialState());
        }
    },

    handleMouseDown: function (e) {
        this.dragging = true;
        this.coords = {
            x: e.pageX,
            y: e.pageY,
        };
    },

    handleMouseUp: function () {
        this.dragging = false;
        this.coords = {};
    },

    handleMouseGoByeBye: function () {
        this.dragging = false;
        this.coords = {};
    },

    handleMouseMove: function (e) {
        if (!this.dragging) {
            return;
        }
        e.preventDefault();

        let divElement        = this.refs.divElement.getDOMNode();

        let xDiff = this.coords.x - e.pageX,
            yDiff = this.coords.y - e.pageY;

        // the maximum amount we are allowed to move the picture by:
        let maxAvailableX = Math.ceil(Math.abs((divElement.clientWidth * this.state.scale - divElement.clientWidth) / 2));
        let maxAvailableY = Math.ceil(Math.abs((divElement.clientHeight * this.state.scale - divElement.clientHeight) / 2));

        this.coords.x = e.pageX;
        this.coords.y = e.pageY;

        let x = this.state.x - xDiff,
            y = this.state.y - yDiff;

        x = this.limitToBound(x, maxAvailableX);
        y = this.limitToBound(y, maxAvailableY);

        this.setState({ x, y, scale: this.state.scale });
    },

    limitToBound: function (value, bound) {
        let isNegativeValue = value < 0;
        let newValue = (Math.abs(value) > bound ? (isNegativeValue ? -1 : 1) * bound : value);
        return newValue;
    },

    isNegative: function (n) {
        return ((n = +n) || 1 / n) < 0;
    },

    handleWheel: function (e) {
        if (!e.shiftKey) {
            return;
        }
        e.preventDefault();

        let direction = this.isNegative(e.deltaX) && this.isNegative(e.deltaY) ? "out" : "in";
        this.zoomImage(direction);
    },

    zoomImageIn: function () {
        this.zoomImage('in');
    },

    zoomImageOut: function () {
        this.zoomImage('out');
    },

    zoomImage: function(direction) {
        const ZOOM_SCALE_INCREMENTOR = 0.1;
        let currentScale = this.state.scale;
        let maxScale = this.state.maxScale;
        let minScale = this.state.minScale;

        if (direction == "in") {
            currentScale += ZOOM_SCALE_INCREMENTOR;
        } else {
            currentScale -= ZOOM_SCALE_INCREMENTOR;
        }

        let divElement        = this.refs.divElement.getDOMNode();
        let maxAvailableX = Math.ceil(Math.abs((divElement.clientWidth * this.state.scale - divElement.clientWidth) / 2));
        let maxAvailableY = Math.ceil(Math.abs((divElement.clientHeight * this.state.scale - divElement.clientHeight) / 2));
        let x = this.limitToBound(this.state.x, maxAvailableX);
        let y = this.limitToBound(this.state.y, maxAvailableY);

        this.setState({ x, y, scale: currentScale < minScale ? minScale : currentScale > maxScale ? maxScale : currentScale });
    },

    fitToWidth: function () {
        let divElement        = this.refs.divElement.getDOMNode();
        let divElementAspectRatio = divElement.clientWidth / divElement.clientHeight;

        let imgWidth = this.props.width;
        let imgHeight = this.props.height;
        let imgAspectRatio = imgWidth / imgHeight;

        if (divElementAspectRatio > imgAspectRatio) {
            let newState = this.getInitialState();
            newState.scale =  divElementAspectRatio / imgAspectRatio;
            this.setState(newState);
        } else {
            this.setState(this.getInitialState());
        }
    },

    fitToPage: function () {
        this.setState(this.getInitialState());
    },

    render() {
        const styles = {
            transform: `translate(${this.state.x}px, ${this.state.y}px) scale(${this.state.scale}, ${this.state.scale})`,
        };
        return (
            <div className={this.props.multipleThumbnails? 'image__viewer image__viewer__thumbnails' :  'image__viewer image__viewer__no__thumbnails'}
                onMouseDown={this.handleMouseDown}
                onMouseUp={this.handleMouseUp}
                onMouseLeave={this.handleMouseGoByeBye}
                onMouseEnter={this.handleMouseEnter} 
                ref="divElement">
                <img className="media__preview__image media__preview__image__listitem"
                    src={this.props.src}
                    style={styles} 
                    draggable={false} />
                <ImageViewerButtons zoomImageIn={this.zoomImageIn}
                    zoomImageOut={this.zoomImageOut}
                    fitToWidth={this.fitToWidth}
                    fitToPage={this.fitToPage} />
            </div>
        )
    }
});

module.exports = ImageViewer;


// WEBPACK FOOTER //
// ./app/components/imageViewer/imageViewer.jsx